module.exports = __webpack_public_path__ + "img/1-2.8fa18802.png";